export const colors = {
	white				: '#FFFFFF',
	black           	: '#22272b',
}
